export { default as LabeledInput } from './LabeledInput.vue';
